import { render, staticRenderFns } from "./RegistrationFormRegTeam.vue?vue&type=template&id=4c1e4478&scoped=true&"
import script from "./RegistrationFormRegTeam.vue?vue&type=script&lang=js&"
export * from "./RegistrationFormRegTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1e4478",
  null
  
)

export default component.exports